import Swiper from 'swiper/bundle';

export default function initSwiperLastsProjets() {
    const thumbsContainer = document.querySelector('.swiper-lastsProjetsThumbs');
    const contentsContainer = document.querySelector('.swiper-lastsProjetsContents');

    if (thumbsContainer && contentsContainer) {
        const swiperLastsProjetsThumbs = new Swiper(thumbsContainer, {
            spaceBetween: 0,
            slidesPerView: 1,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
            freeMode: false,
            watchSlidesProgress: true,
            allowTouchMove: false,
            simulateTouch: false,
        });

        const swiperLastsProjetsContent = new Swiper(contentsContainer, {
            spaceBetween: 30,
            breakpoints: {
                1200: {
                    spaceBetween: 60,
                },
            },
            navigation: {
                nextEl: ".block-cta-realisations .swiper-next",
                prevEl: ".block-cta-realisations .swiper-prev",
            },
            thumbs: {
                swiper: swiperLastsProjetsThumbs,
            },
            allowTouchMove: true,
            simulateTouch: false,
        });
    }
}
